import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
const { md } = { ...baseVariables.mediaQuery };

export const StyledRiottMedia = styled.div`
  .riott-media {
    width: 100%;

    &__width {
      width: 100%;
    }

    &__image_container {
      width: 100%;
    }

    &__authoring_container {
      width: 100%;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__skelton {
      overflow: hidden;
      width: 100%;
      &-image {
        width: 100%;
        aspect-ratio: 1 / 1;

        @media ${md} {
          aspect-ratio: 570 / 49;
        }
      }
    }
  }
`;
